export default (val = "") => {
  const atpos = val.indexOf("@");
  const dotpos = val.lastIndexOf(".");
  if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= val.length) {
    return false;
  }
  return true;
};
